import { Injectable, Injector, inject } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { OsType } from 'src/app/typescript/osType';
import { Globals } from 'src/app/admin/globals.service';

@Injectable()
export class HeadersInterceptor implements HttpInterceptor {
  private injector = inject(Injector);
  private _globalsService: Globals | null = null;

  private get globalsService(): Globals {
    if (!this._globalsService) {
      this._globalsService = this.injector.get(Globals);
    }
    return this._globalsService;
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let headers: HttpHeaders = new HttpHeaders();
    headers = request.headers.append('x-os-type', OsType.WEB.toString());
    headers = headers.append('x-app-version', this.globalsService.version.toString());
    request = request.clone({
      headers: headers,
      url: request.url,
    });
    return next.handle(request);
  }
}
